var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 426,
    viewBox: "0 0 425 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.834 395.067C316.73 395.067 400.954 383.387 400.954 368.978C400.954 354.57 316.73 342.889 212.834 342.889C108.938 342.889 24.7139 354.57 24.7139 368.978C24.7139 383.387 108.938 395.067 212.834 395.067Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.986 322.136C179.023 319.457 178.916 315.744 178.277 311.384C177.738 307.711 176.018 295.978 169.831 287.112C160.481 273.712 149.882 279.686 139.017 265.832C132.799 257.903 134.548 253.748 127.437 247.401C121.155 241.795 114.412 239.73 107.227 238.549C89.0458 235.558 59.3833 238.363 59.3833 238.363C61.8874 267.114 71.5519 279.001 79.8921 284.548C91.5966 292.333 100.6 287.564 111.032 296.882C124.612 309.011 115.698 322.755 128.363 335.375C128.363 335.375 133.908 340.9 176.937 349.078L178.986 322.136Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.937 349.077C176.937 349.077 143.697 292.503 131.034 281.416C118.372 270.328 59.3833 238.363 59.3833 238.363",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.07 262.49L64.939 264.568",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.74 267.085L112.204 239.548",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.623 277.995L94.4858 289.868",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.219 292.107L144.354 271.23",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.59 306.899L119.458 312.585",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.711 319.368L170.427 287.997",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.101 331.157L130.091 336.465",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.222 326.566C158.232 324.077 156.714 320.686 154.457 316.901C152.555 313.712 146.481 303.529 137.375 297.7C123.613 288.891 116.102 298.463 100.767 289.813C91.9912 284.863 92.0192 280.355 83.0219 277.208C75.0745 274.427 68.0535 275.097 60.9636 276.751C43.0193 280.936 16.6812 294.865 16.6812 294.865C29.9837 320.476 43.4579 327.767 53.2847 329.705C67.076 332.424 73.5734 324.578 86.7747 329.201C103.96 335.219 100.975 351.327 117.502 358.148C117.502 358.148 124.737 361.134 167.626 352.245L159.222 326.566Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.626 352.244C167.626 352.244 115.285 312.67 99.3471 307.264C83.4079 301.857 16.6812 294.865 16.6812 294.865",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3481 300.846L31.8301 316.958",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1924 302.161L65.9448 275.773",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9633 305.79L68.8042 329.045",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.921 313.634L107.763 292.762",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.158 323.34L100.562 340.493",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.428 331.758L138.264 298.29",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.762 339.827L119.516 358.496",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M280.33 352.675H166.994L177.909 277.73H269.415L280.33 352.675Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.578 290.943H82.7458C75.5854 290.943 69.7808 285.139 69.7808 277.978V100.428C69.7808 93.268 75.5854 87.4634 82.7458 87.4634H364.578C371.738 87.4634 377.543 93.268 377.543 100.428V277.978C377.543 285.139 371.738 290.943 364.578 290.943Z",
    fill: "#455A64"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.109 269.595H90.2136C83.0532 269.595 77.2485 263.791 77.2485 256.63V106.554C77.2485 99.394 83.0532 93.5894 90.2136 93.5894H357.11C364.271 93.5894 370.075 99.394 370.075 106.554V256.63C370.075 263.791 364.271 269.595 357.109 269.595Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.352 358.132H142.971V350.336C142.971 344.308 147.857 339.421 153.886 339.421H293.437C299.465 339.421 304.352 344.308 304.352 350.336V358.132Z",
    fill: "#6795C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7959 269.596H355.115",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.075 354.234V350.142C150.075 347.666 152.082 345.659 154.558 345.659H275.594",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M262.73 296.933L267.017 329.677",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.955 287.211C224.422 287.211 227.234 284.4 227.234 280.932C227.234 277.465 224.422 274.653 220.955 274.653C217.487 274.653 214.676 277.465 214.676 280.932C214.676 284.4 217.487 287.211 220.955 287.211Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M310.287 105.536H343.615C349.966 105.536 355.115 110.685 355.115 117.036V186.286",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M335.721 127.473C337.646 122.842 339.549 119.26 341.431 116.727C343.312 114.195 345.762 112.176 348.783 110.669C350.548 109.746 352.387 109.084 354.305 108.684C356.219 108.284 358.041 107.775 359.772 107.159C361.499 106.544 363.089 105.707 364.541 104.653C365.992 103.599 367.191 101.935 368.137 99.6577C369.735 95.8123 369.794 92.6818 368.311 90.2703C366.828 87.8589 364.633 86.0484 361.729 84.8414C357.567 83.1116 354.22 83.0793 351.689 84.7419C349.155 86.4054 346.876 89.1177 344.853 92.8798L329.664 86.566C331.263 82.7206 333.342 79.4872 335.904 76.8692C338.464 74.2521 341.36 72.3251 344.59 71.0892C347.818 69.855 351.307 69.3246 355.055 69.5014C358.8 69.6774 362.637 70.5818 366.563 72.2138C375.041 75.7379 381.014 80.2471 384.486 85.7407C387.955 91.2351 388.077 97.8668 384.846 105.638C383.801 108.152 382.632 110.242 381.34 111.915C380.045 113.586 378.57 114.975 376.914 116.082C375.256 117.188 373.404 118.099 371.359 118.814C369.311 119.529 367.054 120.201 364.583 120.83C362.3 121.447 360.393 122.105 358.861 122.802C357.327 123.5 356.023 124.363 354.954 125.39C353.881 126.417 352.981 127.587 352.254 128.893C351.525 130.202 350.803 131.721 350.086 133.447L335.721 127.473ZM325.803 150.004L332.216 134.578L348.111 141.186L341.699 156.612L325.803 150.004Z",
    fill: "#455A64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M243.095 150.624V138.027C243.095 133.895 239.745 130.545 235.613 130.545H162.49C158.358 130.545 155.008 133.895 155.008 138.027V150.624V234.546C155.008 238.678 158.358 242.028 162.49 242.028H279.421C283.553 242.028 286.903 238.678 286.903 234.546V158.105C286.903 153.973 283.553 150.624 279.421 150.624H243.095Z",
    fill: "#D4E1EF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M235.687 168.219L220.955 182.951L206.224 168.22L197.333 177.109L212.065 191.841L197.333 206.573L206.224 215.463L220.955 200.731L235.687 215.463L244.577 206.573L229.845 191.841L244.577 177.109L235.687 168.219Z",
    fill: "#6795C8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3336 357.406V347.706H43.4717V374.378L83.8025 375.025V370.176L61.3336 357.406Z",
    fill: "#F7A99C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2303 375.025V372.726C85.2303 370.375 83.9408 368.214 81.8719 367.097L64.8626 357.917C59.7634 359.31 55.8228 359.115 53.13 358.659C48.6582 357.899 44.3844 355.868 42.9462 357.567C42.5348 358.053 42.4855 358.691 42.5016 359.129V373.233C42.5016 374.223 43.304 375.025 44.2934 375.025H85.2303Z",
    fill: "#2667B0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2305 373.489H42.501",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8155 364.022L73.4219 367.186",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0621 363.032L71.6685 366.195",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2304 362.115L69.8359 365.278",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5323 360.438C66.6338 361.543 61.85 362.961 55.8108 362.929C49.984 362.897 45.3592 361.528 42.5015 360.438",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.253 357.406V347.706H94.3906V374.378L134.721 375.025V370.176L112.253 357.406Z",
    fill: "#F7A99C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136.149 375.025V372.726C136.149 370.375 134.86 368.214 132.791 367.097L115.782 357.917C110.682 359.31 106.742 359.115 104.049 358.659C99.5771 357.899 95.3033 355.868 93.8651 357.567C93.4537 358.053 93.4044 358.691 93.4206 359.129V373.233C93.4206 374.223 94.223 375.025 95.2124 375.025H136.149Z",
    fill: "#2667B0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.149 373.489H93.4204",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M126.734 364.022L124.341 367.186",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.981 363.032L122.587 366.195",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M123.149 362.115L120.756 365.278",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.451 360.438C117.553 361.543 112.769 362.961 106.73 362.929C100.904 362.897 96.2781 361.528 93.4204 360.438",
    fill: "#2667B0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M120.451 360.438C117.553 361.543 112.769 362.961 106.73 362.929C100.904 362.897 96.2781 361.528 93.4204 360.438",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.988 219.276C101.988 219.276 116.698 265.993 118.961 272.459C121.223 278.925 123.325 287.978 122.84 295.898C122.355 303.819 114.757 352.636 114.757 352.636H92.6114C92.6114 352.636 91.0474 301.07 90.2934 297.029C89.5395 292.988 83.0735 270.129 83.0735 270.129C83.0735 270.129 80.9723 296.868 79.1941 303.98C77.4159 311.093 63.1912 353.445 63.1912 353.445H42.5005L51.23 219.276H101.988Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.749 190.798C135.749 190.798 142.773 184.84 144.55 180.941C146.071 177.605 148.198 171.744 148.78 170.123C148.867 169.879 149.124 169.744 149.376 169.803L149.797 169.902C151.1 170.211 151.905 171.52 151.592 172.822L150.891 175.745L158.312 170.871C158.949 170.452 159.807 170.658 160.184 171.32C160.517 171.904 160.358 172.645 159.815 173.041L154.92 176.611L163.052 172.792C163.682 172.497 164.432 172.735 164.777 173.339L164.788 173.357C165.152 173.997 164.93 174.811 164.289 175.176L164.38 175.15C165.087 174.946 165.836 175.289 166.143 175.955C166.5 176.727 166.138 177.64 165.35 177.959L164.833 178.168C165.508 177.957 166.216 178.378 166.354 179.071C166.556 180.084 166.068 181.106 165.152 181.583C162.963 182.722 161.543 183.022 159.463 184.579C157.817 185.811 158.393 186.596 156.637 188.842C154.498 191.578 152.677 191.656 148.993 194.364C147.594 195.392 145.662 196.995 143.62 199.381L135.749 190.798Z",
    fill: "#F7A99C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M160.302 171.613C160.302 171.613 160.675 172.37 159.966 172.909C159.258 173.448 153.728 177.541 153.728 177.541",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.29 175.176L156.675 178.71",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.073 178.122L157.418 181.645",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M150.329 170.1C150.329 170.1 151.667 170.946 151.629 171.885C151.592 172.823 150.242 178.851 150.242 178.851",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6121 352.637C92.6121 352.637 90.6078 299.764 90.4514 298.397C90.295 297.03 82.7598 269.045 82.7598 269.045L84.0943 256.676C84.0943 256.676 99.2965 294.098 99.2965 296.566C99.2965 299.036 100.985 352.637 100.985 352.637H92.6121Z",
    fill: "#3F535E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0576 300.744L85.4602 242.312",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.609 348.151H92.4414L92.6123 352.637H114.758L115.609 348.151Z",
    fill: "#262626"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5342 349.438H42.7614L42.5005 353.445H63.192L64.5342 349.438Z",
    fill: "#262626"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M116.957 277.079C119.889 286.308 120.354 296.307 118.29 305.767",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 184.515C141.588 184.515 137.837 187.402 133.565 188.152C128.56 189.031 124.219 186.066 123.053 185.27C119.879 183.103 118.707 180.535 116.609 177.53C110.392 168.631 106.53 163.102 101.124 159.972C98.3302 158.353 93.6578 156.527 86.2917 157.092C84.6393 156.5 82.0051 156.969 80.2405 156.969C78.7734 156.969 77.3072 156.969 75.8401 156.969C72.9484 157.316 51.6508 159.79 48.0298 156.465C46.6026 155.154 46.5797 153.863 46.5797 153.863C46.561 152.795 47.235 151.684 48.9996 150.34C53.3117 147.057 61.2218 144.606 63.8712 143.824L62.2545 131.751C62.2545 131.751 62.2545 131.751 58.6981 131.751C55.1417 131.751 42.5328 133.852 35.7439 136.225C26.2247 139.551 21.1247 141.978 18.6087 147.492C15.4569 154.402 18.8144 161.828 19.6865 163.758C24.0572 173.425 33.7489 177.337 39.6029 179.7C44.7658 181.785 49.3609 182.622 52.5552 182.994L49.8071 226.963L100.345 229.711H107.934C108.516 222.993 105.609 202.118 105.985 195.3C112.438 204.279 123.126 208.814 133.272 206.864C144.505 204.706 150.154 195.546 151.074 194C147.153 186.266 141.588 184.515 141.588 184.515Z",
    fill: "#2667B0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7971 181.33H78.3101V160.345H81.4933V178.634C81.4933 180.123 80.2863 181.33 78.7971 181.33Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M108.012 227.392C106.271 227.715 82.3495 231.726 65.4464 213.879C51.1834 198.819 52.8698 179.761 53.1673 176.943C52.2799 190.162 51.3917 203.381 50.5043 216.6H50.4558L49.8081 226.962L57.7301 227.393L57.725 227.337C69.54 228.272 81.7333 228.97 94.2869 229.381C98.8854 229.532 103.435 229.64 107.936 229.711C107.961 228.937 107.986 228.165 108.012 227.392Z",
    fill: "#6795C8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6107 141.084C95.4768 136.639 95.3417 133.164 95.0901 130.943C94.8988 129.253 94.6047 127.974 93.7071 126.757C93.5176 126.501 92.0267 124.54 89.4682 124.029C86.4082 123.416 85.6355 125.639 81.2827 126.178C77.5291 126.642 76.7896 125.152 74.2651 126.222C71.5077 127.391 70.1468 130.12 69.7337 130.949C69.5535 131.311 68.6551 133.162 68.5641 135.756C68.4919 137.811 68.9611 139.356 69.1472 139.988C69.9292 142.65 70.8498 146.697 71.9752 153.168C72.5625 153.146 73.1507 153.125 73.7381 153.103C80.6962 149.095 87.6534 145.089 94.6107 141.084Z",
    fill: "#262626"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7282 162.948C76.4404 162.96 73.7654 160.305 73.7535 157.018L73.7051 144.209L85.6102 144.164L85.6586 156.973C85.6705 160.26 83.016 162.935 79.7282 162.948Z",
    fill: "#F7A99C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85.644 153.387L77.8911 149.404C77.9693 150.075 78.4105 153.219 81.1755 155.391C82.941 156.778 84.7974 157.095 85.6542 157.185L85.644 153.387Z",
    fill: "#FF9186"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4158 140.24C73.3784 140.046 72.8684 139.754 72.712 139.654C72.4477 139.485 72.1612 139.35 71.862 139.254C71.2815 139.067 70.6431 139.024 70.0464 139.161C68.8598 139.433 67.8075 140.43 67.6095 141.651C67.4947 142.361 67.6588 143.094 67.9622 143.746C68.4195 144.725 69.1947 145.548 70.1314 146.086C70.9075 146.534 71.7906 146.787 72.6831 146.84C72.8616 146.85 74.6917 146.808 74.6781 146.738C74.2565 144.572 73.8357 142.406 73.4158 140.24Z",
    fill: "#F7A99C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7836 140.364C71.9247 141.319 72.7645 146.361 77.3086 149.922C78.1459 150.579 83.71 154.94 88.8015 152.811C95.3439 150.076 94.6299 139.33 94.584 138.748C94.4285 136.78 93.9686 130.986 89.1704 127.895C85.2544 125.372 81.0104 126.299 80.4086 126.441C79.7745 126.59 75.7344 127.61 73.2618 131.571C71.0169 135.165 71.5533 138.8 71.7836 140.364Z",
    fill: "#F7A99C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8706 138.756C90.976 139.595 91.6228 140.204 92.3156 140.117C93.0083 140.031 93.4843 139.28 93.3789 138.441C93.2735 137.602 92.6267 136.993 91.9339 137.08C91.2412 137.166 90.7652 137.917 90.8706 138.756Z",
    fill: "#262626"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3105 139.705C83.4159 140.544 84.0627 141.154 84.7555 141.067C85.4482 140.98 85.9242 140.23 85.8188 139.391C85.7134 138.552 85.0666 137.943 84.3738 138.029C83.6819 138.116 83.2051 138.866 83.3105 139.705Z",
    fill: "#262626"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5885 140.011L89.747 141.577C89.9604 141.864 89.8805 142.273 89.5745 142.459L88.5103 143.107",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7753 143.657C80.8934 144.598 81.7528 145.266 82.6937 145.147C83.6347 145.029 84.3028 144.169 84.1838 143.228C84.0656 142.287 83.2063 141.619 82.2653 141.738C81.3244 141.856 80.6571 142.716 80.7753 143.657Z",
    fill: "#FF9186"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6167 144.545C72.6227 144.356 72.638 143.077 71.6129 142.155C70.8096 141.433 69.8746 141.385 69.6196 141.381",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7126 142.408C71.6557 142.399 70.968 142.304 70.4878 142.824C70.0925 143.251 70.1291 143.78 70.1367 143.868",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6333 139.19C71.6333 139.19 72.4791 139.265 73.1166 139.898C73.7541 140.531 73.9802 141.615 73.9802 141.615C75.6096 141.417 79.342 140.729 82.7275 137.79C84.5627 136.198 85.683 134.475 86.3434 133.234C86.9605 133.789 88.0137 134.623 89.5037 135.265C91.4477 136.103 93.8761 136.504 94.1983 135.852C94.2578 135.731 94.1923 135.381 94.0597 134.681C94.0121 134.428 93.962 134.053 93.8387 133.694C93.5982 132.992 93.2854 132.315 92.9122 131.673C92.1642 130.39 91.1689 129.25 89.9976 128.336C89.236 127.743 88.4004 127.245 87.5113 126.866C84.6893 125.666 80.7708 125.665 77.398 127.464C77.398 127.464 73.6325 129.472 71.9725 133.403C71.4021 134.753 71.2585 136.104 71.2228 136.572C71.1514 137.5 71.2559 138.106 71.397 138.572C71.4769 138.835 71.5662 139.047 71.6333 139.19Z",
    fill: "#262626"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6926 140.94C94.0181 140.899 94.3318 140.957 94.6106 141.084C94.5774 142.006 94.489 143.125 94.2859 144.311C94.2306 144.324 94.1779 144.342 94.121 144.35C93.18 144.468 92.3207 143.8 92.2025 142.859C92.0844 141.919 92.7508 141.058 93.6926 140.94Z",
    fill: "#FF9186"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81.087 126.659C80.5277 126.442 79.7083 126.145 78.6994 125.855C76.4877 125.221 75.3818 124.904 74.3754 125.033C71.4293 125.412 69.737 129.294 69.0272 130.923C68.49 132.155 67.6111 134.247 68.0769 136.868C68.2843 138.034 68.6949 138.946 69.0213 139.549",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0869 126.309C82.0831 125.874 83.1482 125.521 84.1078 125.022C85.1151 124.499 85.9948 123.818 87.0735 123.416C88.2065 122.993 89.4713 122.824 90.6282 123.175C91.6252 123.478 92.4778 124.144 93.1816 124.913C94.1293 125.948 94.851 127.198 95.2267 128.55C95.9509 131.156 95.304 133.872 94.8773 136.469",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8666 146.693C89.8666 147.54 89.0421 148.226 88.0255 148.226C87.0081 148.226 86.1836 147.54 86.1836 146.693C86.1836 145.847 87.0081 145.161 88.0255 145.161C89.0421 145.161 89.8666 145.847 89.8666 146.693Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5322 133.822L65.9331 131.751C65.9331 131.751 66.6275 128.755 67.5719 128.121C68.5162 127.488 73.5346 125.539 73.5346 125.539L74.2656 126.222C74.2656 126.222 70.3386 129.809 69.5252 131.402C68.7109 132.994 68.5579 137.429 68.5579 137.429L64.7159 142.396L63.7758 143.108L62.5322 133.822Z",
    fill: "#F7A99C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1673 178.851L51.3789 201.829",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M105.109 180.73L106.48 206.083",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5954 144.544C25.8848 145.11 22.2094 148.15 21.6144 153.521C20.9667 159.373 24.4857 163.378 25.0357 163.983",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M113.913 196.988C114.858 198.038 118.533 201.868 124.709 202.703C130.567 203.495 134.937 201.088 136.196 200.333",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M274.498 217.118L282.382 212.904L294.076 215.048L299.923 208.811L313.761 212.514L321.461 201.989L335.209 210.416L330.531 180.698L312.39 167.996L270.696 174.558C269.135 174.804 268.069 176.268 268.315 177.83L274.498 217.118Z",
    fill: "#F5F5F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.628 182.886L330.531 180.698L312.391 167.996L314.489 181.328C314.649 182.349 315.607 183.046 316.628 182.886Z",
    fill: "#D6D6D6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M312.391 167.995L314.489 181.327C314.65 182.348 315.608 183.045 316.629 182.885L330.532 180.697",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M280.118 256.139C280.364 257.701 281.828 258.766 283.39 258.521L338.008 249.925C339.57 249.679 340.636 248.215 340.39 246.653L335.208 213.729L321.461 205.302L313.761 215.827L299.923 212.123L294.076 218.361L282.382 216.217L274.498 220.431L280.118 256.139Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M274.509 217.118L282.393 212.904L294.088 215.048L299.935 208.811L313.773 212.514L321.472 201.989L335.22 210.416L330.542 180.698L312.402 167.996L270.707 174.558C269.146 174.804 268.08 176.268 268.326 177.83L274.509 217.118Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M280.129 256.139C280.375 257.701 281.84 258.766 283.401 258.521L338.02 249.925C339.581 249.679 340.647 248.215 340.401 246.653L335.22 213.729L321.472 205.302L313.772 215.827L299.934 212.123L294.087 218.361L282.393 216.217L274.509 220.431L280.129 256.139Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2068 124.683L61.8281 125.999L49.6323 114.987L53.1428 111.639L63.2068 124.683Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2202 122.425L64.3459 122.772L60.1631 106.882L64.9333 106L66.2202 122.425Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7211 127.68L59.5646 129.58L43.1333 129.455L43.532 124.621L59.7211 127.68Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M256.027 368.601C251.905 364.549 251.847 357.923 255.899 353.8L304.088 304.766L319.018 319.439L270.828 368.472C266.777 372.595 260.15 372.653 256.027 368.601Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M342.012 323.531C365.385 323.477 384.29 304.485 384.236 281.112C384.182 257.738 365.191 238.834 341.817 238.888C318.444 238.941 299.539 257.933 299.593 281.306C299.647 304.68 318.638 323.584 342.012 323.531Z",
    fill: "#DCF0FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.299 296.135C303.726 299.932 305.715 303.563 308.269 306.899L384.217 280.63C384.16 276.524 383.506 272.427 382.263 268.476L302.299 296.135Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.684 284.017C299.842 286.418 300.205 288.806 300.771 291.157L380.393 263.617C379.4 261.445 378.218 259.341 376.839 257.33L299.684 284.017Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M376.14 246.384C356.901 227.476 325.977 227.744 307.068 246.984C288.16 266.223 288.429 297.147 307.668 316.056C326.907 334.964 357.832 334.695 376.74 315.456C395.649 296.216 395.38 265.291 376.14 246.384ZM313.71 309.908C297.866 294.337 297.645 268.87 313.216 253.025C328.788 237.181 354.254 236.96 370.098 252.531C385.942 268.102 386.163 293.569 370.592 309.414C355.022 325.258 329.554 325.479 313.71 309.908Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M307.471 323.95L269.367 362.721",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M345.407 235.886C333.401 234.675 320.955 238.819 312.071 246.984C303.187 255.15 298.011 267.204 298.208 279.268",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty_data.c35776cd3df757e6a952a4601273fded.svg";
export { ForwardRef as ReactComponent };